<template>
  <div>
    <v-autocomplete
      ref="control"
      v-if="l_visible"
      :errorMessages="errorMessages"
      @input="
        newVal => {
          setDirty(true);
          update(newVal);
        }
      "
      :value="idSprostredkovatela"
      outlined
      :items="items"
      :loading="isLoading"
      hide-no-data
      :label="l_label"
      class="dynamic-input-control"
      :append-icon="isDisabled ? '' : 'mdi-chevron-down'"
      :search-input.sync="search"
      :disabled="isDisabled"
      :rules="getRules"
      :placeholder="placeholder"
      :class="{
        validated: displayValidated && !hasError && !errorMessages,
        required: l_required,
        readonly,
      }"
      return-object
      :readonly="isLoading || isDisabled"
      item-text="display_member"
      item-value="value_member"
      @focusout="focusout"
      clearable
    >
      <template v-slot:label>
        {{ getLabel }}
        <span v-if="optional" class="optional">(nepovinné)</span>
      </template>
      <template v-slot:append>
        <slot name="append" v-if="!isDisabled"></slot>
        <div class="v-input__icon v-input__icon--append" v-if="!isDisabled">
          <v-icon>mdi-chevron-down</v-icon>
        </div>
        <v-tooltip v-if="!!getTooltip" bottom max-width="350">
          <template v-slot:activator="{ on }">
            <v-icon slot="activator" class="btn-help text-body-2 ml-2" v-on="on"
              >mdi-help-circle</v-icon
            >
          </template>
          <span> {{ getTooltip }} </span>
        </v-tooltip>
      </template>
    </v-autocomplete>
  </div>
</template>
<script>
import { dynamicControlMixin } from '../../mixins/dynamicControlMixin';
import protectedAxios from '../../auth/axios.js';

export default {
  mixins: [dynamicControlMixin],
  props: {
    value: Number,
    placeholder: String,
    optional: Boolean,
  },
  data() {
    return {
      data: null,
      isLoading: false,
      search: null,
      loadingTimeout: null,
      items: [],
      currentItem: null,
      idSprostredkovatela: null,
      VYHLADAVANIE_DELAY: 500,
    };
  },
  watch: {
    search(val) {
      const currentValue = this.currentItem ? this.currentItem.display_member : null;
      if (val === currentValue) return;
      if (!val || val.length < 3) {
        this.items = [];
        return;
      }

      clearTimeout(this.loadingTimeout);

      this.loadingTimeout = setTimeout(
        () => this.findSprostredkovatel(val, false),
        this.VYHLADAVANIE_DELAY
      );
    },
    value() {
      if (!this.value) {
        this.update(null);
        return;
      }
      if (this.value !== this.idSprostredkovatela) {
        //ak ico zmeni obchodne meno, musim vyhladat obchodne meno spolu icom
        this.findSprostredkovatel(this.value, true);
      }
    },
  },
  methods: {
    focusout() {
      if (this.idSprostredkovatela && !this.search)
        this.findSprostredkovatel('@' + this.idSprostredkovatela, false);
    },
    readData(config, data) {
      if (config.controlValue) {
        this.idSprostredkovatela = config.controlValue;
        this.$emit('input', this.idSprostredkovatela);
        return this.findSprostredkovatel('@' + config.controlValue, true);
      } else this.update(null);
    },
    update(newVal) {
      if (this.currentItem?.value_member !== newVal?.value_member) {
        this.currentItem = newVal;
      }
      if (this.idSprostredkovatela !== newVal?.value_member) {
        this.idSprostredkovatela = newVal?.value_member;
        this.$emit('input', this.idSprostredkovatela);
        return this.saveValue(this.idSprostredkovatela, true);
      }
    },
    findSprostredkovatel(query, updateVal) {
      this.isLoading = true;

      let url = `controls/sprostredkovatel?query=${encodeURIComponent(
        query
      )}&cisloPredmetu=${encodeURIComponent(
        this.l_cisloPredmetu ?? ''
      )}&newId=${this.pripad?.newId ?? ''}`;

      return protectedAxios
        .get(url)
        .then(res => {
          this.isLoading = false;

          if (Array.isArray(res.data)) this.items = res.data;

          if (query.startsWith('@'))
            this.update(this.items.find(i => i.value_member == query.replace('@', '')));
          else if (updateVal) {
            this.update(this.items.find(i => i.display_member === query));
          }
        })
        .catch(e => {
          console.error(e);
          this.errorMessages = 'Chyba pri načítaní dát.';
          this.isLoading = false;
          if(e?.onlyInterceptor)
            return;
        });
    },
    // setIdSprostredkovatela(val) {
    //   this.findSprostredkovatel('@' + val);
    // },
  },
};
</script>
